import { Button, Checkbox, FormControlLabel, Grid, Typography } from "@mui/material"
import { MANAGEMENT_APIS } from "../../common/apis";
import useFetch from "../../hooks/useFetch";
import { useEffect } from "react";
import { useState } from "react";

const GlobalSettings = ({ cancel }) => {

    const { get } = useFetch();
    const [useQC, setUseQC] = useState(false);
    const [sampleImageCheck, setSampleImageCheck] = useState(false);
    
    const getBillingRates = async () => {
        const bills = await get(`${MANAGEMENT_APIS.GLOBAL_SETTINGS}?SettingsId=${2}`)
        const sampleImage = await get(`${MANAGEMENT_APIS.GLOBAL_SETTINGS}?SettingsId=${6}`)
        setUseQC(bills?.SettingsValue);
        setSampleImageCheck(sampleImage?.SettingsValue)
    }

    const handleSaveClick = async () => {
        await get(`${MANAGEMENT_APIS.EDIT_GLOBAL_SETTINGS}?SettingsId=${2}&SettingValue=${useQC}`)
        await get(`${MANAGEMENT_APIS.EDIT_GLOBAL_SETTINGS}?SettingsId=${6}&SettingValue=${sampleImageCheck}`)
        cancel && cancel()
    }

    useEffect(() => { getBillingRates() }, [])

    return (
        <Grid
            container
            spacing={1}
            sx={{ minWidth: "25vw", minHeight: "25vh", }}
        >
            <Grid item size={{ xs: 12 }}>
                <Grid item size={{ xs: 12 }} mt={1}>
                    <Typography>Settings for all users and products</Typography>
                    <Grid item size={{ xs: 6 }} mt={1}>
                        <FormControlLabel
                            checked={useQC}
                            control={<Checkbox />}
                            label="Use Quality Check"
                            onChange={() => setUseQC(!useQC)}
                        />
                    </Grid>
                    <Grid item size={{ xs: 6 }} mt={1}>
                        <FormControlLabel
                            checked={sampleImageCheck}
                            control={<Checkbox />}
                            label="Sample Report Image Check"
                            onChange={() => setSampleImageCheck(!sampleImageCheck)}
                        />
                    </Grid>
                </Grid>

                <Grid item xs={12} sx={{ position: "absolute", right: "25px", bottom: "25px" }} onClick={handleSaveClick}>
                    <Button>Save</Button>
                </Grid>
            </Grid>
        </Grid>
    )
}
export default GlobalSettings;